import React, {useState} from 'react';
import {Select} from 'antd';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import TimeSeriesLineChart from '../../../../components/admin/reports/charts/TimeSeriesLineChart';
import {dateFormat} from '../../../../utils/utils';

const GROUP_BY_OPTIONS = [
    {value: 'day', label: 'Dia'},
    {value: 'week', label: 'Semana'},
    {value: 'month', label: 'Mês'},
];

const PERIOD_FORMAT = {day: 'DD/MM', week: 'DD/MM', month: 'MMM/YY'};

export default function RegistrationsChart({dateFrom, dateTo}) {
    const [groupBy, setGroupBy] = useState('month');
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_PATIENTS_REGISTRATIONS,
        params: {date_from: dateFrom, date_to: dateTo, group_by: groupBy},
        dataDefault: {},
    });
    const series = data?.series || [];

    return (
        <ReportChartCard
            title="Novos Cadastros de Pacientes"
            loading={isLoading}
            isEmpty={!series.length}
            extra={<Select value={groupBy} onChange={setGroupBy} options={GROUP_BY_OPTIONS} size="small" style={{width: 110}}/>}
        >
            <TimeSeriesLineChart
                data={series}
                dataKey="count"
                periodFormatter={(value) => dateFormat(value, PERIOD_FORMAT[groupBy])}
                tooltipFields={[{key: 'count', label: 'Cadastros'}]}
            />
        </ReportChartCard>
    );
}
